import { render, staticRenderFns } from "./ChatButtonProxy.vue?vue&type=template&id=4959b848&"
import script from "./ChatButtonProxy.vue?vue&type=script&lang=ts&"
export * from "./ChatButtonProxy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports